import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type BlockContentId = Branded<string, "BlockContentId">;
const {
    factory: blockContentIdFactory,
    assert: isBlockContentId,
    zodSchema: blockContentIdZodSchema,
} = genericId<BlockContentId>("block_content__");

export { blockContentIdFactory, blockContentIdZodSchema, isBlockContentId };
export type { BlockContentId as BlockContentId };
